<template>
	<div class="bs-center">
		<div style="height:20%">
			<div class="bsbox-w">
				<ZCshujugailan  @data-click="handleDataClick"/>
			</div>
		</div>
		<div class="map" style="height: 50%;">
			<Map />
		</div>

		<div style="height:30%">
			<div class="bsbox-w">
				<ZCzichanyingshou />
			</div>
		</div>
	</div>
</template>

<script>
	import Map from "./components/map.vue";//中间地图
	import ZCshujugailan from "../../views/index/charts/ZCshujugailan.vue"; //顶部数据概览
	import ZCzichanyingshou from "../../views/index/charts/ZCzichanyingshou.vue"; //顶部数据概览
	import apis from "@/http/apis";



	export default {
		components: {
			Map,//中间地图
			ZCshujugailan,
			ZCzichanyingshou
		},
		props: {
			fullWidth: {
				type: String,
				default: "1000px",
			},
		},
		data() {
			return {
				isFull: false,
				list: [],
			};
		},
		created() {
			this.apidata();
		},
		methods: {
			apidata() {
				apis.todayData()
					.then((res) => {
						this.list = res.data.list
					})

			},
			handleDataClick(data) {
				// 将事件传递给父组件（index.vue）
				this.$emit('data-click', data);
			}
		},
	};
</script>

<style lang="scss" scoped>
	.bs-center {
		padding: 10px 0px 20px;
		width: calc(33% - 0px);
		height: calc(100% - 30px);
		flex-shrink: 0;
		flex-grow: 0;
	}

	.bsbox-w {
		display: flex;
		height:100%;
	}

	.bsbox {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.map {
		width: 100%;
		/* height: calc(88% - 50px); */
		position: relative;
		z-index: 0;
		isolation: isolate;
	}
</style>